import React from "react"
import {
  type IconProps,
  iconColorCss,
  iconSizeCss,
} from "@myvp/shared/src/styles/icon-utils"

const TextSearch = (props: IconProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    focusable="false"
    css={[iconColorCss(props.color), iconSizeCss(props.size)]}
  >
    <path
      d="M21 4C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H3C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4H21Z"
      fill="var(--color)"
    />
    <path
      d="M12.6667 8.66406C13.403 8.66406 14 9.11178 14 9.66406C14 10.2163 13.403 10.6641 12.6667 10.6641H3.33333C2.59695 10.6641 2 10.2163 2 9.66406C2 9.11178 2.59695 8.66406 3.33333 8.66406H12.6667Z"
      fill="var(--color)"
    />
    <path
      d="M10 13.3359C10.5523 13.3359 11 13.7837 11 14.3359C11 14.8882 10.5523 15.3359 10 15.3359H3C2.44772 15.3359 2 14.8882 2 14.3359C2 13.7837 2.44772 13.3359 3 13.3359H10Z"
      fill="var(--color)"
    />
    <path
      d="M10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H3C2.44772 20 2 19.5523 2 19C2 18.4477 2.44772 18 3 18H10Z"
      fill="var(--color)"
    />
    <path
      d="M19 15C19 13.8954 18.1046 13 17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17C18.1046 17 19 16.1046 19 15ZM21 15C21 17.2091 19.2091 19 17 19C14.7909 19 13 17.2091 13 15C13 12.7909 14.7909 11 17 11C19.2091 11 21 12.7909 21 15Z"
      fill="var(--color)"
    />
    <path
      d="M18.3925 16.3945C18.783 16.0039 19.416 16.0039 19.8066 16.3945L21.707 18.2948C22.0971 18.6854 22.0973 19.3185 21.707 19.7089C21.3166 20.0993 20.6834 20.099 20.2929 19.7089L18.3925 17.8085C18.002 17.418 18.002 16.785 18.3925 16.3945Z"
      fill="var(--color)"
    />
  </svg>
)

export default TextSearch
